import SGIButton from './components/SGIButton';
const sgi = {
    key: 'sgi',
    Content: SGIButton,
    group: 3
};
/**
 * A hook that returns the SGI button.
 *
 * @returns {Object}
 */
export function useSgiButton() {
    return sgi;
}
